import {reqUserInfo,reqLogout} from '@/api'
import {Message} from 'element-ui'
import {deleteToken} from '@/utils/auth' 
import store from '@/store' 
import router from '@/router' 

// actions中的方法用于响应组件中的动作 —— 服务员
const actions = {
  // 获取用户信息
  async getUserInfo({commit}){
    // 发请求获取信息
    const {code,message,data} = await reqUserInfo()
    if(code === 200){
      commit('SAVE_USER_INFO',data)
    }else{
      Message.warning('身份过期，请重新登录！')
      // 加上下面这行代码，目的是：让getUserInfo这个“服务员”可以反馈工作成果
      return Promise.reject()
    }
  },
  async logout({commit},value){
    // 请求退出登录
    const {code,message} = await reqLogout()
    if(code === 200){
      // 提示
      value ? Message.warning(value) : Message.success('退出登录成功！')
      //删除token
      deleteToken()
      //清除vuex中的信息
      commit('CLEAR_USER_INFO')
      //跳转到/login
      router.push('/login')
    }else{
      Message.warning(`退出登录失败:${message}`)
    }
  }
}

// mutations中的方法用于修改状态 —— 厨师
const mutations = {
  SAVE_USER_INFO(state,value){
    state.info = value
  },
  CLEAR_USER_INFO(state){
    state.info = {}
  }
}

// state用于指定初始的数据 —— 原材料
const state = {
  info:{}
}

export default {
  namespaced:true,
  actions,
  mutations,
  state
}